import React from 'react';
import { Award, Target, Zap } from 'lucide-react';

const About = () => {
  return (
    <section style={{
      padding: '120px 40px',
      background: '#000000'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div className="fade-in" style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="section-title">
            Desenvolvimento Web de <span className="gold-gradient">Elite</span>
          </h2>
          <p className="section-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Especializado em criar experiências digitais únicas que elevam marcas e geram resultados mensuráveis.
            Cada projeto é tratado como uma obra-prima digital.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '40px'
        }}>
          {[
            {
              icon: <Target size={40} />,
              title: 'Estratégia Orientada',
              description: 'Cada linha de código é pensada para converter. Não criamos sites, criamos máquinas de vendas digitais que trabalham 24/7 para o seu negócio.'
            },
            {
              icon: <Zap size={40} />,
              title: 'Performance Superior',
              description: 'Tecnologia de ponta com carregamento instantâneo. Sites rápidos não são luxo, são necessidade. Cada segundo de atraso custa dinheiro.'
            },
            {
              icon: <Award size={40} />,
              title: 'Qualidade Premium',
              description: 'Design exclusivo e código impecável. Seu site merece o mesmo nível de excelência que você entrega aos seus clientes. Sem atalhos, sem compromissos.'
            }
          ].map((item, idx) => (
            <div
              key={idx}
              className="fade-in"
              style={{
                background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.05) 0%, transparent 100%)',
                border: '1px solid rgba(212, 175, 55, 0.2)',
                borderRadius: '12px',
                padding: '40px',
                transition: 'transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
                transitionDelay: `${idx * 0.2}s`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.6)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(212, 175, 55, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{ color: '#D4AF37', marginBottom: '20px' }}>
                {item.icon}
              </div>
              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: '24px',
                fontWeight: '600',
                marginBottom: '15px',
                color: '#FFFFFF'
              }}>
                {item.title}
              </h3>
              <p style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '16px',
                fontWeight: '300',
                color: '#CCCCCC',
                lineHeight: '1.8'
              }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;